import {
  ADD_POST,
  LOADING_POSTS,
  GET_POSTS,
  LIKE_POST_SUCCESS,
  UNLIKE_POST_SUCCESS,
  POST_ERROR,
  DELETE_POST_ERROR,
  DELETE_POST_SUCCESS,
  LIKE_POST_ERROR,
  UNLIKE_POST_ERROR,
  UPDATE_POST_ERROR,
  UPDATE_POST_SUCCESS,
} from "../constants";

const initialState = {
  list: [],
  loading: false,
  error: null,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case ADD_POST:
      return {
        ...state,
        list: [action.payload, ...state.list],
      };

    case LOADING_POSTS:
      return {
        ...state,
        loading: true,
      };

    case GET_POSTS:
      return {
        ...state,
        loading: false,
        list: action.payload,
      };

    case LIKE_POST_SUCCESS:
    case UNLIKE_POST_SUCCESS:
      return {
        ...state,
        list: state.list.map((post) =>
          post._id === action.payload.postId
            ? { ...post, likes: action.payload.likes }
            : post
        ),
        error: null,
      };
    case POST_ERROR:

    case LIKE_POST_ERROR:
    case UNLIKE_POST_ERROR:
      return {
        ...state,
        error: action.payload,
      };

    case DELETE_POST_SUCCESS:
      return {
        ...state,
        list: state.list.filter((post) => post._id !== action.payload), // remove the deleted post
        error: null,
      };

    case DELETE_POST_ERROR:
      return {
        ...state,
        error: action.payload,
      };

    case UPDATE_POST_SUCCESS:
      return {
        ...state,
        list: state.list.map((post) =>
          post._id === action.payload._id ? action.payload : post
        ),
      };

    case UPDATE_POST_ERROR:
      return {
        ...state,
        error: action.payload.error,
      };

    default:
      return state;
  }
}
